import { BlipNamespace, BlipNamespaceOptions } from "@/common/BlipNamespace";

export const ReportChannel = Object.freeze(BlipNamespace);
export const ReportChannelOptions = Object.freeze(BlipNamespaceOptions);
